<template>
    <div class="tsoft-header">
      <div class="d-flex align-items-center">
        <div>
          <router-link to="/dashboard">
            <img :src="'/img/logo-tanasoft.svg'" />
          </router-link>
        </div>
      </div>
      <div class="d-flex align-items-center ml-4" style="overflow-x: auto; overflow-y: hidden;">
        <!-- <div class="mr-3" v-if="orderKanban">
          <b-input-group class="search-wrapper">
            <template #prepend>
              <div class="d-flex align-items-center cursor-pointer header-search-icon" @click="onShowSearchInput">
                <transition name="slide-up">
                  <b-icon-x-circle style="position: absolute;" v-if="searchIsClicked" variant="primary" key="search"/>
                  <b-icon-search style="position: absolute;" v-else-if="!searchIsClicked" variant="primary" key="close"/>
                </transition>
              </div>
            </template>
            <b-form-input
              ref="onSearch"
              placeholder="Поиск"
              trim
              :class="[searchIsClicked ? '' : 'visible', 'border-0', 'py-1', 'pr-3', 'pl-0', 'form-input']" 
              v-model="searchText"
              @input="onEmitSearch"
            />
          </b-input-group>
        </div> -->
        <!-- <div class="mr-3" v-if="orderKanban">
          <button
            v-b-toggle.create-order-modal
            class="btn btn-success"
          >
            Создать заявку
          </button>
        </div> -->
        <div class="mr-3">
          <TaskSidebarLink />
        </div>
        <!-- <div class="mr-3">
          <router-link to="/motivation">
            <b-iconstack font-scale="2.5" class="cursor-pointer">
              <b-icon stacked icon="circle-fill" variant="light-gray"></b-icon>
              <b-icon
                stacked
                icon="award-fill"
                scale="0.5"
                variant="brown"
              ></b-icon>
            </b-iconstack>
          </router-link>
        </div> -->
        <div class="mr-3">
          <router-link to="/tickets">
            <b-iconstack font-scale="2.5" class="cursor-pointer">
              <b-icon stacked icon="circle-fill" variant="light-gray"></b-icon>
              <b-icon
                stacked
                icon="bug-fill"
                variant="brown"
                scale="0.5"
              ></b-icon>
            </b-iconstack>
          </router-link>
        </div>
        <div class="mr-3">
          <router-link to="/help">
            <b-iconstack font-scale="2.5" class="cursor-pointer">
              <b-icon stacked icon="circle-fill" variant="light-gray"></b-icon>
              <b-icon
                stacked
                icon="question-circle-fill"
                variant="brown"
                scale="0.5"
              ></b-icon>
            </b-iconstack>
          </router-link>
        </div>
        <div class="mr-3">
          <tsoft-sidebar-notifications />
        </div>
        <div class="mr-3">
          <router-link to="/profile">
            <div class="tsoft-user-preview">
              <template v-if="currentUser.avatar_path">
                <img :src="currentUser.avatar_path" alt="userPhoto" />
              </template>
              <template v-else>
                <b-avatar
                  :title="currentUser.name"
                  :size="28"
                  variant="secondary"
                  :text="nameAvatar(currentUser.name)"
                ></b-avatar>
              </template>
              <span class="font-weight-bold text-brown mx-2 hidden-from-1141">{{
                currentUser.name
              }}</span>
            </div>
          </router-link>
        </div>
        <div>
          <div @click="logout">
            <b-iconstack font-scale="2.5" class="cursor-pointer">
              <b-icon stacked icon="circle-fill" variant="light-gray"></b-icon>
              <b-icon
                stacked
                icon="door-open"
                scale="0.5"
                variant="brown"
              ></b-icon>
            </b-iconstack>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { mixinTasks } from "@/mixins";
  import debounce from "@/services/helpers";
  import { mapGetters, mapActions } from "vuex";
  
  import SidebarNotifications from "@/components/notifications/SidebarNotifications.vue";
  import TaskSidebarLink from "@/components/task/TaskSidebarLink.vue";
  
  export default {
    mixins: [mixinTasks],
    components: {
      "tsoft-sidebar-notifications": SidebarNotifications,
      TaskSidebarLink,
    },
    data() {
      return {
        searchText: '',
        searchIsClicked: false
      };
    },
  
    watch: {
      '$route.query.kanban_type': function() {
        this.searchIsClicked = false;
        this.searchText = '';
        this.$emit('search', this.searchText);
      },
    },
  
    computed: {
      ...mapGetters("auth", ["currentUser"]),
  
      orderKanban() {
        return this.$route.path === '/order-kanban' ? true : false;
      }
    },
  
    methods: {
      ...mapActions("auth", ["AUTH_LOGOUT"]),
  
      logout() {
        this.AUTH_LOGOUT().then(() => {
          this.$toast.success("Выход выполнен успешно. Хорошего дня! ☀️", {
            position: "top-right",
            timeout: 3000,
            closeOnClick: true,
            pauseOnFocusLoss: false,
            pauseOnHover: false,
            draggable: true,
            draggablePercent: 1,
            showCloseButtonOnHover: true,
            hideProgressBar: true,
            closeButton: "button",
            icon: "fa fa-exclamation-triangle",
            rtl: false,
          });
          this.$router.push("/login");
        });
      },
  
      onEmitSearch: debounce(function() {
        this.$emit('search', this.searchText)
      }, 1000),
  
      onShowSearchInput() {
        this.searchIsClicked = !this.searchIsClicked;
        if (!this.searchIsClicked) {
          this.searchText = '';
          this.onEmitSearch();
        } else {
          this.$refs.onSearch.focus();
        }
      }
    },
    mounted() {
    },
  };
  </script>
  